var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',[_c('h3',{staticClass:"overlay-size"},[_vm._v(" "+_vm._s(this.bits)+" ")])]):_c('div',[_vm._v(" Loading.... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }